import React from 'react';
import { useDispatch } from 'react-redux';
import './MenuHeader.css';
import { ArrowBack } from '@mui/icons-material';
import { showSidebar } from '../../redux/slices/uiSlice';
import Image from '../../assets/images';
import theme from '../../config/theme';

const MenuHeader = () => {
  const dispatch = useDispatch();
  return (
    <div className='menu-header'>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div id={'showSidebar'} className='menu-sidebar-button' onClick={() => dispatch(showSidebar(false))}>
          <ArrowBack className='sidebar-button-icon' />
        </div>
        <div className='container-header-logo'>
          <img alt='logo' className='header-logo' src={Image[theme.code].logo} />
        </div>
      </div>
      <div style={{ borderTop: '1px solid #FFFFFF', margin: '0 10px' }} />
    </div>
  )
}

export default MenuHeader;